<template>
  <div class="flex size-full items-center justify-center">
    <BaseCard>
      <p class="text-error">
        This merchant does not have Beepaid GO enabled
      </p>
    </BaseCard>
  </div>
</template>
